import { Injectable } from '@rxdi/core';

@Injectable()
export class ScrollToService {
  #elements: HTMLElement[];

  scrollToElement(elementName: string): void {
    this.#elements
      .find((el) => el.localName === elementName)
      ?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
  }

  setElements(elements: HTMLElement[]): void {
    this.#elements = elements;
  }
}
